const req = require.context('./', true, /.js$/);
const whenDirectoryOnlyIndexAllowToExport = /^\.\/(?:\w{1,50}\/index|\w{1,50})\.js$/
const modules = req.keys().filter((dirname) => whenDirectoryOnlyIndexAllowToExport.test(dirname)).map(req);

module.exports = modules.reduce((result, current) => {
	const keys = Object.keys(current);
	return keys.reduce((r, key) => {
		r[key] = current[key];
		return r;
	}, result);
}, {});
